"use strict";
import React, { useRef } from "react";
import * as styles from "./ChoiceChips-css";
import { Text } from "../Text";
import classNames from "classnames";
import { randomString } from "../../../utils";
const ChipsContext = React.createContext(null);
export const ChoiceChips = ({
  onChange,
  value,
  children,
  label,
  labelHidden = true,
  align = "center"
}) => {
  const labelId = useRef(`choicechips-${randomString()}`).current;
  return /* @__PURE__ */ React.createElement("div", { className: styles.container({ align }), role: "radiogroup", "aria-labelledby": labelId }, /* @__PURE__ */ React.createElement(Text, { strong: true, id: labelId, className: styles.label({ hidden: labelHidden }), element: "label", size: "s" }, label), /* @__PURE__ */ React.createElement("div", { className: styles.chipWrapper({ align }) }, /* @__PURE__ */ React.createElement(ChipsContext.Provider, { value: { selectedValue: value, onChange } }, children)));
};
export const ChoiceChipsOption = ({ label, value }) => /* @__PURE__ */ React.createElement(ChipsContext.Consumer, null, (ctx) => {
  if (!ctx) {
    console.error("Component <ChoiceChipsOption /> must be rendered inside a <ChoiceChips /> container");
    return null;
  }
  const isSelected = ctx.selectedValue === value;
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      role: "radio",
      "aria-checked": isSelected,
      onClick: () => ctx.onChange(value),
      className: classNames(["button-mixin", styles.chip({ isSelected })])
    },
    /* @__PURE__ */ React.createElement(Text, { className: styles.chipText({ isSelected }), size: "s", align: "center" }, label)
  );
});
